// Email service utility using Google Apps Script
export const emailService = {
  // Google Apps Script web app URL - replace with your deployed script URL
  scriptUrl: 'https://script.google.com/macros/s/AKfycbzJI3oA-3LBq9qcInxXM6jHzKbJlrLbLd1AnKSiSKac5i_UD2g_utzGG4m-gZpHGyzi/exec',

  // Send email using Google Apps Script
  async sendEmail(subject, formData, formType) {
    try {
      // Prepare the data to send to Google Apps Script
      const data = {
        ...formData,
        'form-type': formType,
        'subject': subject,
        'timestamp': new Date().toLocaleString()
      };

      // Method 1: Try with CORS mode
      try {
        const response = await fetch(this.scriptUrl, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(data)
        });

        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }

        const result = await response.json();
        
        if (result.status === 'success') {
          console.log('Email sent successfully via Google Apps Script');
          return { success: true, message: 'Email sent successfully!' };
        } else {
          throw new Error('Failed to send email');
        }
      } catch (corsError) {
        console.log('CORS error detected, trying alternative method...');
        
        // Method 2: Use no-cors mode (this will work but we won't get a response)
        try {
          await fetch(this.scriptUrl, {
            method: 'POST',
            mode: 'no-cors',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify(data)
          });

          // With no-cors, we can't read the response, but the request will be sent
          console.log('Request sent with no-cors mode');
          return { success: true, message: 'Email sent successfully! (no-cors mode)' };
        } catch (noCorsError) {
          console.log('No-cors also failed, trying CORS proxy...');
          
          // Method 3: Use CORS proxy
          const corsProxyUrl = 'https://cors-anywhere.herokuapp.com/';
          const proxyResponse = await fetch(corsProxyUrl + this.scriptUrl, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'Origin': window.location.origin
            },
            body: JSON.stringify(data)
          });

          if (!proxyResponse.ok) {
            throw new Error(`Proxy request failed: ${proxyResponse.status}`);
          }

          const proxyResult = await proxyResponse.json();
          
          if (proxyResult.status === 'success') {
            console.log('Email sent successfully via CORS proxy');
            return { success: true, message: 'Email sent successfully! (via proxy)' };
          } else {
            throw new Error('Failed to send email via proxy');
          }
        }
      }

    } catch (error) {
      console.error('Email sending failed:', error);
      return { success: false, message: 'Failed to send email. Please try again.' };
    }
  },

  // Send doctor loan application
  async sendDoctorLoanEmail(formData) {
    const subject = 'New Doctor Loan Application';
    return await this.sendEmail(subject, formData, 'doctor-loan');
  },

  // Send equipment loan application
  async sendEquipmentLoanEmail(formData) {
    const subject = 'New Equipment Loan Application';
    return await this.sendEmail(subject, formData, 'equipment-loan');
  },

  // Send project loan application
  async sendProjectLoanEmail(formData) {
    const subject = 'New Project Loan Application';
    return await this.sendEmail(subject, formData, 'project-loan');
  },

  // Send contact form
  async sendContactEmail(formData) {
    const subject = 'New Contact Form Submission';
    return await this.sendEmail(subject, formData, 'contact');
  },

  // Send mortgage loan application
  async sendMortgageLoanEmail(formData) {
    const subject = 'New Mortgage Loan Application';
    return await this.sendEmail(subject, formData, 'mortgage-loan');
  },

  // Send home loan application
  async sendHomeLoanEmail(formData) {
    const subject = 'New Home Loan Application';
    return await this.sendEmail(subject, formData, 'home-loan');
  },

  // Send agriculture loan application
  async sendAgricultureLoanEmail(formData) {
    const subject = 'New Agriculture Loan Application';
    return await this.sendEmail(subject, formData, 'agriculture-loan');
  },

  // Send education loan application
  async sendEducationLoanEmail(formData) {
    const subject = 'New Education Loan Application';
    return await this.sendEmail(subject, formData, 'education-loan');
  },

  // Format doctor loan application email (for reference)
  formatDoctorLoanEmail(formData) {
    return `
      <h2>New Doctor Loan Application</h2>
      <table style="border-collapse: collapse; width: 100%;">
        <tr><td style="padding: 8px; border: 1px solid #ddd;"><strong>Full Name:</strong></td><td style="padding: 8px; border: 1px solid #ddd;">${formData.name}</td></tr>
        <tr><td style="padding: 8px; border: 1px solid #ddd;"><strong>Email:</strong></td><td style="padding: 8px; border: 1px solid #ddd;">${formData.email}</td></tr>
        <tr><td style="padding: 8px; border: 1px solid #ddd;"><strong>Phone:</strong></td><td style="padding: 8px; border: 1px solid #ddd;">${formData.phone}</td></tr>
        <tr><td style="padding: 8px; border: 1px solid #ddd;"><strong>PAN Number:</strong></td><td style="padding: 8px; border: 1px solid #ddd;">${formData.pan}</td></tr>
        <tr><td style="padding: 8px; border: 1px solid #ddd;"><strong>Loan Amount Required:</strong></td><td style="padding: 8px; border: 1px solid #ddd;">${formData.amount}</td></tr>
      </table>
      <p><strong>Submission Time:</strong> ${new Date().toLocaleString()}</p>
    `;
  },

  // Format equipment loan application email (for reference)
  formatEquipmentLoanEmail(formData) {
    return `
      <h2>New Equipment Loan Application</h2>
      <table style="border-collapse: collapse; width: 100%;">
        <tr><td style="padding: 8px; border: 1px solid #ddd;"><strong>Full Name:</strong></td><td style="padding: 8px; border: 1px solid #ddd;">${formData.name}</td></tr>
        <tr><td style="padding: 8px; border: 1px solid #ddd;"><strong>Email:</strong></td><td style="padding: 8px; border: 1px solid #ddd;">${formData.email}</td></tr>
        <tr><td style="padding: 8px; border: 1px solid #ddd;"><strong>Phone:</strong></td><td style="padding: 8px; border: 1px solid #ddd;">${formData.phone}</td></tr>
        <tr><td style="padding: 8px; border: 1px solid #ddd;"><strong>Date of Birth:</strong></td><td style="padding: 8px; border: 1px solid #ddd;">${formData.dob}</td></tr>
        <tr><td style="padding: 8px; border: 1px solid #ddd;"><strong>PAN Number:</strong></td><td style="padding: 8px; border: 1px solid #ddd;">${formData.pan}</td></tr>
        <tr><td style="padding: 8px; border: 1px solid #ddd;"><strong>Education:</strong></td><td style="padding: 8px; border: 1px solid #ddd;">${formData.education}</td></tr>
        <tr><td style="padding: 8px; border: 1px solid #ddd;"><strong>Experience:</strong></td><td style="padding: 8px; border: 1px solid #ddd;">${formData.experience}</td></tr>
        <tr><td style="padding: 8px; border: 1px solid #ddd;"><strong>Loan Amount:</strong></td><td style="padding: 8px; border: 1px solid #ddd;">${formData.amount}</td></tr>
        <tr><td style="padding: 8px; border: 1px solid #ddd;"><strong>Equipment Description:</strong></td><td style="padding: 8px; border: 1px solid #ddd;">${formData.equipment}</td></tr>
      </table>
      <p><strong>Submission Time:</strong> ${new Date().toLocaleString()}</p>
    `;
  },

  // Format project loan application email (for reference)
  formatProjectLoanEmail(formData) {
    return `
      <h2>New Project Loan Application</h2>
      <table style="border-collapse: collapse; width: 100%;">
        <tr><td style="padding: 8px; border: 1px solid #ddd;"><strong>Company Name:</strong></td><td style="padding: 8px; border: 1px solid #ddd;">${formData.company}</td></tr>
        <tr><td style="padding: 8px; border: 1px solid #ddd;"><strong>Contact Person:</strong></td><td style="padding: 8px; border: 1px solid #ddd;">${formData.contact}</td></tr>
        <tr><td style="padding: 8px; border: 1px solid #ddd;"><strong>Mobile:</strong></td><td style="padding: 8px; border: 1px solid #ddd;">${formData.mobile}</td></tr>
        <tr><td style="padding: 8px; border: 1px solid #ddd;"><strong>Email:</strong></td><td style="padding: 8px; border: 1px solid #ddd;">${formData.email}</td></tr>
        <tr><td style="padding: 8px; border: 1px solid #ddd;"><strong>Type of Hospital:</strong></td><td style="padding: 8px; border: 1px solid #ddd;">${formData.type}</td></tr>
        <tr><td style="padding: 8px; border: 1px solid #ddd;"><strong>Number of Beds:</strong></td><td style="padding: 8px; border: 1px solid #ddd;">${formData.beds}</td></tr>
        <tr><td style="padding: 8px; border: 1px solid #ddd;"><strong>Premises:</strong></td><td style="padding: 8px; border: 1px solid #ddd;">${formData.premises}</td></tr>
      </table>
      <p><strong>Submission Time:</strong> ${new Date().toLocaleString()}</p>
    `;
  },

  // Format contact form email (for reference)
  formatContactEmail(formData) {
    return `
      <h2>New Contact Form Submission</h2>
      <table style="border-collapse: collapse; width: 100%;">
        <tr><td style="padding: 8px; border: 1px solid #ddd;"><strong>Name:</strong></td><td style="padding: 8px; border: 1px solid #ddd;">${formData.name}</td></tr>
        <tr><td style="padding: 8px; border: 1px solid #ddd;"><strong>Email:</strong></td><td style="padding: 8px; border: 1px solid #ddd;">${formData.email}</td></tr>
        <tr><td style="padding: 8px; border: 1px solid #ddd;"><strong>Phone:</strong></td><td style="padding: 8px; border: 1px solid #ddd;">${formData.phone}</td></tr>
        <tr><td style="padding: 8px; border: 1px solid #ddd;"><strong>Message:</strong></td><td style="padding: 8px; border: 1px solid #ddd;">${formData.message}</td></tr>
      </table>
      <p><strong>Submission Time:</strong> ${new Date().toLocaleString()}</p>
    `;
  },

  // Format mortgage loan application email (for reference)
  formatMortgageLoanEmail(formData) {
    return `
      <h2>New Mortgage Loan Application</h2>
      <table style="border-collapse: collapse; width: 100%;">
        <tr><td style="padding: 8px; border: 1px solid #ddd;"><strong>Full Name:</strong></td><td style="padding: 8px; border: 1px solid #ddd;">${formData.name}</td></tr>
        <tr><td style="padding: 8px; border: 1px solid #ddd;"><strong>Email:</strong></td><td style="padding: 8px; border: 1px solid #ddd;">${formData.email}</td></tr>
        <tr><td style="padding: 8px; border: 1px solid #ddd;"><strong>Phone:</strong></td><td style="padding: 8px; border: 1px solid #ddd;">${formData.phone}</td></tr>
        <tr><td style="padding: 8px; border: 1px solid #ddd;"><strong>PAN Number:</strong></td><td style="padding: 8px; border: 1px solid #ddd;">${formData.pan}</td></tr>
        <tr><td style="padding: 8px; border: 1px solid #ddd;"><strong>Property Details:</strong></td><td style="padding: 8px; border: 1px solid #ddd;">${formData.property}</td></tr>
        <tr><td style="padding: 8px; border: 1px solid #ddd;"><strong>Loan Amount Required:</strong></td><td style="padding: 8px; border: 1px solid #ddd;">${formData.amount}</td></tr>
      </table>
      <p><strong>Submission Time:</strong> ${new Date().toLocaleString()}</p>
    `;
  },

  formatHomeLoanEmail(formData) {
    return `
      <h2>New Home Loan Application</h2>
      <table style="border-collapse: collapse; width: 100%;">
        <tr><td style="padding: 8px; border: 1px solid #ddd;"><strong>Full Name:</strong></td><td style="padding: 8px; border: 1px solid #ddd;">${formData.name}</td></tr>
        <tr><td style="padding: 8px; border: 1px solid #ddd;"><strong>Email:</strong></td><td style="padding: 8px; border: 1px solid #ddd;">${formData.email}</td></tr>
        <tr><td style="padding: 8px; border: 1px solid #ddd;"><strong>Phone:</strong></td><td style="padding: 8px; border: 1px solid #ddd;">${formData.phone}</td></tr>
        <tr><td style="padding: 8px; border: 1px solid #ddd;"><strong>PAN Number:</strong></td><td style="padding: 8px; border: 1px solid #ddd;">${formData.pan}</td></tr>
        <tr><td style="padding: 8px; border: 1px solid #ddd;"><strong>Property Details:</strong></td><td style="padding: 8px; border: 1px solid #ddd;">${formData.property}</td></tr>
        <tr><td style="padding: 8px; border: 1px solid #ddd;"><strong>Loan Amount Required:</strong></td><td style="padding: 8px; border: 1px solid #ddd;">${formData.amount}</td></tr>
      </table>
      <p><strong>Submission Time:</strong> ${new Date().toLocaleString()}</p>
    `;
  },

  // Format agriculture loan application email (for reference)
  formatAgricultureLoanEmail(formData) {
    return `
      <h2>New Agriculture Loan Application</h2>
      <table style="border-collapse: collapse; width: 100%;">
        <tr><td style="padding: 8px; border: 1px solid #ddd;"><strong>Full Name:</strong></td><td style="padding: 8px; border: 1px solid #ddd;">${formData.name}</td></tr>
        <tr><td style="padding: 8px; border: 1px solid #ddd;"><strong>Email:</strong></td><td style="padding: 8px; border: 1px solid #ddd;">${formData.email}</td></tr>
        <tr><td style="padding: 8px; border: 1px solid #ddd;"><strong>Phone:</strong></td><td style="padding: 8px; border: 1px solid #ddd;">${formData.phone}</td></tr>
        <tr><td style="padding: 8px; border: 1px solid #ddd;"><strong>PAN Number:</strong></td><td style="padding: 8px; border: 1px solid #ddd;">${formData.pan}</td></tr>
        <tr><td style="padding: 8px; border: 1px solid #ddd;"><strong>Land Details:</strong></td><td style="padding: 8px; border: 1px solid #ddd;">${formData.land}</td></tr>
        <tr><td style="padding: 8px; border: 1px solid #ddd;"><strong>Loan Amount Required:</strong></td><td style="padding: 8px; border: 1px solid #ddd;">${formData.amount}</td></tr>
      </table>
      <p><strong>Submission Time:</strong> ${new Date().toLocaleString()}</p>
    `;
  },

  // Format education loan application email (for reference)
  formatEducationLoanEmail(formData) {
    return `
      <h2>New Education Loan Application</h2>
      <table style="border-collapse: collapse; width: 100%;">
        <tr><td style="padding: 8px; border: 1px solid #ddd;"><strong>Full Name:</strong></td><td style="padding: 8px; border: 1px solid #ddd;">${formData.name}</td></tr>
        <tr><td style="padding: 8px; border: 1px solid #ddd;"><strong>Email:</strong></td><td style="padding: 8px; border: 1px solid #ddd;">${formData.email}</td></tr>
        <tr><td style="padding: 8px; border: 1px solid #ddd;"><strong>Phone:</strong></td><td style="padding: 8px; border: 1px solid #ddd;">${formData.phone}</td></tr>
        <tr><td style="padding: 8px; border: 1px solid #ddd;"><strong>PAN Number:</strong></td><td style="padding: 8px; border: 1px solid #ddd;">${formData.pan}</td></tr>
        <tr><td style="padding: 8px; border: 1px solid #ddd;"><strong>Course / Program:</strong></td><td style="padding: 8px; border: 1px solid #ddd;">${formData.course}</td></tr>
        <tr><td style="padding: 8px; border: 1px solid #ddd;"><strong>Study Location:</strong></td><td style="padding: 8px; border: 1px solid #ddd;">${formData.location}</td></tr>
        <tr><td style="padding: 8px; border: 1px solid #ddd;"><strong>Loan Amount Required:</strong></td><td style="padding: 8px; border: 1px solid #ddd;">${formData.amount}</td></tr>
      </table>
      <p><strong>Submission Time:</strong> ${new Date().toLocaleString()}</p>
    `;
  }
}; 